import React, { useState, useEffect } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { PatientDialog } from "@/components/opd/PatientDialog";
import { Search, UserPlus, X } from "lucide-react";

// Inline patient search + select. onChange receives the selected patient object.
export function PatientPicker({ value, onChange, testId = "patient-picker" }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [openList, setOpenList] = useState(false);
  const [regOpen, setRegOpen] = useState(false);

  useEffect(() => {
    if (!openList) return;
    const t = setTimeout(() => {
      api.get(`/opd/patients?search=${encodeURIComponent(q)}&limit=8`).then((r) => setResults(r.data)).catch(() => setResults([]));
    }, 200);
    return () => clearTimeout(t);
  }, [q, openList]);

  if (value) {
    return (
      <div className="flex items-center justify-between border border-slate-200 rounded-md px-3 py-2 bg-slate-50" data-testid={`${testId}-selected`}>
        <div><div className="text-sm font-medium text-slate-800">{value.name}</div><div className="text-xs text-slate-400 font-mono">{value.uhid} · {value.gender}, {value.age}y · {value.mobile}</div></div>
        <Button variant="ghost" size="icon" onClick={() => onChange(null)} data-testid={`${testId}-clear`}><X className="h-4 w-4" /></Button>
      </div>
    );
  }

  return (
    <div className="relative" data-testid={testId}>
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-slate-400" />
          <Input className="pl-8" placeholder="Search name / mobile / UHID" value={q} onFocus={() => setOpenList(true)} onChange={(e) => { setQ(e.target.value); setOpenList(true); }} data-testid={`${testId}-input`} />
        </div>
        <Button type="button" variant="outline" onClick={() => setRegOpen(true)} data-testid={`${testId}-register`}><UserPlus className="h-4 w-4 mr-1.5" /> New</Button>
      </div>
      {openList && results.length > 0 && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-slate-200 rounded-md shadow-lg max-h-64 overflow-y-auto thin-scroll">
          {results.map((p) => (
            <button key={p.id} type="button" onClick={() => { onChange(p); setOpenList(false); }} data-testid={`${testId}-opt-${p.id}`}
              className="w-full text-left px-3 py-2 hover:bg-blue-50 border-b border-slate-100 last:border-0">
              <div className="text-sm font-medium text-slate-800">{p.name}</div>
              <div className="text-xs text-slate-400 font-mono">{p.uhid} · {p.gender}, {p.age}y · {p.mobile}</div>
            </button>
          ))}
        </div>
      )}
      <PatientDialog open={regOpen} onOpenChange={setRegOpen} onSaved={(p) => onChange(p)} />
    </div>
  );
}
